// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"251":"0567abc2","567":"0567abc2","602":"0567abc2"}[chunkId] + ".chunk.css";
};